import classNames from "classnames";
import classes from "../../Step1/UploadProfessionalDocuments/UploadProffesionalDocuments.module.scss";
import {CustomModal, ModalActions, ModalBody, ModalHeader} from "../../../../../../../base/components/CustomModal";
import React from "react";
import Button from "../../../../../../../base/components/Button";
import {BUTTON_COLORS} from "../../../../../../../base/components/Button/appearance";
import {FormAvatar} from "../../../../../../../base/components/Dropzone/Dropzone";
import {DropZonePlaceholder, validateFile} from "../../../../../../app/Fitness/WorkoutForm/form";
import {AVATAR_FILE_TYPE} from "../../../../../../../base/constants/shared";
import {useLoading} from "../../../../../../../base/hooks/useLoading";
import useUploadImages from "../../../../../../../base/components/Dropzone/useUploadImages";

const UploadAvatarModal = ({
                               file,
                               isOpen,
                               updateIsOpen,
                               setFieldValue,
                               setFieldTouched
                           }) => {

    const [isLoading, {registerPromise}] = useLoading();
    const uploadImage = useUploadImages();

    const onClose = () => {
        updateIsOpen(false)
    }

    const onSave = () => {
        const controller = new AbortController();
        const abortSignal = controller.signal;

        registerPromise(uploadImage(file[0].file, AVATAR_FILE_TYPE, abortSignal, file[0].name))
            .then((data) => {
                setFieldTouched('file', true)
                setFieldValue('file', [data])
            })
            .finally(() => {
                onClose()
            })
    }

    return(
        <CustomModal isOpen={isOpen} className={classNames("partner-professional-documents-modal", classes.Modal)}
                     contentClassName={classes.ModalContent}>
            <ModalHeader onClose={onClose} sectionClassName={classes.ModalHeader}
                         className={classNames(classes.TextBlack, "font-size-24 font-weight-semibold partner-text-black")}>
                Upload profile picture
            </ModalHeader>
            <ModalBody className={classes.ModalBody}>
                <FormAvatar
                    validateFile={validateFile}
                    dropZonePlaceholder={<DropZonePlaceholder fileType={"image"} />}
                    dropZoneTitle="Upload profile picture"
                    editModalClassName="partner-profile-edit-modal"
                    editModalTitle="Crop profile picture"
                />
            </ModalBody>
            <ModalActions>
                <Button
                    color={BUTTON_COLORS.secondary}
                    type="button"
                    onClick={onClose}
                    className={classNames(classes.BtnSecondary, "me-3")}
                >
                    <span className={classes.TextBlack}>Discard</span>
                </Button>
                <Button
                    color={BUTTON_COLORS.primary}
                    type="button"
                    className={classes.BtnPrimary}
                    onClick={onSave}
                    disabled={!file?.length}
                    loading={isLoading}
                >
                    Save
                </Button>
            </ModalActions>
        </CustomModal>
    )
}

export default UploadAvatarModal